import Vue from 'vue';
export default new Vue();

/*
* 位置：main.js
* 功能：分发事件routerChange
*       路由发生改变的时候触发
*  bus.$emit('routerChange',to,from)
* */

/*
 * 位置：main.js
 * 功能：分发事件leftActive
 *       路由发生改变的时候触发
 *  bus.$emit('leftActive',to,from)
 * */

/*
*  位置：layout.vue
*  功能：分发事件 layout_showDialog
*       点击快速查看排班
*  bus.$emit('layout_showDialog')
* */

/*
 *  位置：layout.vue
 *  用于：layoutSchedule.vue
 *  功能：分发事件 layout_showDialog
 *  bus.$emit('layout_showDialog')
 * */

/*
 *  位置：main.js
 *  用于：layout.vue
 *  功能：分发事件 layout_Tab
 *       点击快速查看排班
 *  bus.$emit('layout_Tab',to)
 * */

/*
 *  位置：personalset.vue
 *  用于：sheelZoonePset.vue
 *  功能：分发事件 layout_Tab
 *       点击快速查看排班
 *  bus.$emit('addSet','add')
 * */



// WEBPACK FOOTER //
// ./src/libs/bus.js